export default __webpack_public_path__ + "static/media/Pigeon_smm.a4a541c0.png";